import React from 'react';
import PropTypes from 'prop-types';
import doneCircleGreenFilledIcon from 'assets/images/icons/done-circle-green-filled.svg';
import timeInfinityGreyIcon from 'assets/images/icons/time-infinity-grey.svg';
import SingleRadioBoxField from 'components/form-components/SingleRadioBoxField';
import SingleCheckBoxField from 'components/form-components/SingleCheckBoxField';
import RecurringSchedule from './RecurringSchedule';
import OneTimeSchedule from './OneTimeSchedule';
import { t } from 'i18next';

const ScheduleSection = ({ values, handleChange, isEdit }) => {
  const { isScheduled, scheduleType, allowOverDue } = values;

  return (
    <div>
      <label className='mb-1'>{t('text_task_types')}</label>

      <div className='border-grey-13-h-1 rounded-sm'>
        {/* Scheduled / Not Scheduled */}
        <div className='p-3 d-flex gap-3 py-2 border-bottom-grey-13-h-1'>
          <SingleRadioBoxField
            name='scheduled'
            value={isScheduled}
            handleChange={(_, value) => handleChange('isScheduled', value)}
            text={<span>{t('text_scheduled')}</span>}
            classes='width-max-content'
            disabled={isEdit && !isScheduled}
          />
          <SingleRadioBoxField
            name='not_scheduled'
            value={!isScheduled}
            handleChange={(_, value) => handleChange('isScheduled', !value)}
            text={<span>{t('text_not_scheduled')}</span>}
            classes='width-max-content'
            disabled={isEdit && isScheduled}
          />
        </div>

        {/* If Scheduled */}
        {isScheduled ? (
          <>
            {/* One-time / Recurring Toggle */}
            <div className='d-flex border-bottom-grey-13-h-1'>
              <div
                className={`w-50 py-2 d-flex gap-3 justify-content-center align-items-center ${
                  scheduleType === 'one_time' ? 'theme-background-green-6' : ''
                } ${isEdit ? '' : 'cursor-pointer'}`}
                onClick={() => {
                  if (!isEdit) handleChange('scheduleType', 'one_time');
                }}
              >
                <span>{t('text_one_time_task')}</span>
                {scheduleType === 'one_time' && (
                  <img className='theme-width-20' src={doneCircleGreenFilledIcon} />
                )}
              </div>

              <div
                className={`w-50 py-2 d-flex gap-3 justify-content-center align-items-center ${
                  scheduleType === 'recurring' ? 'theme-background-green-6' : ''
                } ${isEdit ? '' : 'cursor-pointer'}`}
                onClick={() => {
                  if (!isEdit) handleChange('scheduleType', 'recurring');
                }}
              >
                <span>{t('text_recurring_task')}</span>
                {scheduleType === 'recurring' && (
                  <img className='theme-width-20' src={doneCircleGreenFilledIcon} />
                )}
              </div>
            </div>

            {/* Schedule Body */}
            <div>
              {scheduleType === 'one_time' ? (
                <OneTimeSchedule values={values} handleChange={handleChange} />
              ) : (
                <RecurringSchedule values={values} handleChange={handleChange} />
              )}
              {/* Allow overdue */}
              <div className='px-3 py-2 border-top-grey-13-h-1'>
                <SingleCheckBoxField
                  name={'allowOverDue'}
                  value={allowOverDue}
                  text={<span>{t('text_allow_after_due_date')}</span>}
                  handleChange={handleChange}
                />
              </div>
            </div>
          </>
        ) : (
          /* Not Scheduled UI */
          <div className='p-5 d-flex flex-column gap-2 justify-content-center align-items-center'>
            <img src={timeInfinityGreyIcon} />
            <span className='theme-size-1_3 theme-font-inter-bold'>
              {t('text_no_schedule_selected')}
            </span>
            <div className='d-flex flex-column text-center'>
              <span>{t('text_this_task_will_have_no_start_date_or_due_date')}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

ScheduleSection.propTypes = {
  values: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  isEdit: PropTypes.bool,
};

export default React.memo(ScheduleSection);
